﻿
// Auto generated by typewriter


export class SnowReportViewModel {
    
    fromDate: Date = null;
    toDate: Date = null;
    includeHistory: boolean = false;
}
